import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    keys = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.getMany, { keys }, options);
    if (error) return { error, status };
    return content || {};
};
